import { useCallback } from 'react';
import { formatCurrency } from '../../../../utils/formatters';

export const useProductsTableCard = () => {
  // Formatear el descuento para mostrar (porcentaje con monto equivalente o monto fijo)
  const formatDiscountDisplay = useCallback(
    (discountType: string, discountValue: number, originalPrice: number) => {
      if (discountType === 'PERCENTAGE') {
        const equivalentAmount = originalPrice * (discountValue / 100);
        return `${discountValue}% (${formatCurrency(equivalentAmount)})`;
      } else {
        return formatCurrency(discountValue);
      }
    },
    [],
  );

  // Formatear precio
  const formatPrice = useCallback((price: number) => {
    return formatCurrency(price);
  }, []);

  return {
    formatDiscountDisplay,
    formatPrice,
  };
};
